import { UnableTimeInfo } from "../../model/UnableTime";
import { axiosUtils } from "../../network/axiosUtils";
import httpRequest from "../../network/httpRequest";
import { UnableTimeBody } from "./types";

const URL = "/repair-shops/bookable/unable-time";

/**
 *장착점 불가시간 리스트 조회
 * @returns
 */
export const fetchUnableTime = async (
  reservationDate?: string
): Promise<UnableTimeInfo[]> => {
  const url = `${URL}`;
  const response = await httpRequest({
    method: axiosUtils.GET,
    url,
    queryParams: { reservationDate },
  });

  return response?.data;
};

/**
 * 장착점 불가시간 등록
 * @returns
 */
export const postUnableTime = async (body: UnableTimeBody) => {
  const url = `${URL}`;
  const response = await httpRequest({
    method: axiosUtils.POST,
    url,
    requestBody: body,
  });

  return response?.data;
};

/**
 *장착점 불가시간 리스트 조회
 * @returns
 */
export const deleteUnableTime = async (body: UnableTimeBody) => {
  const url = `${URL}`;
  const response = await httpRequest({
    method: axiosUtils.DELETE,
    url,
    requestBody: body,
  });

  return response?.data;
};
